import allowedNameRegex from 'common/constants/regex/allowedNameRegex';

export default (value = '') => value.replace(allowedNameRegex, '');
